import React from "react";

import { useDispatch, useSelector } from "react-redux";

import IconButton from "@mui/material/IconButton";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";

const theme = createTheme({
  palette: {
    neutral: {
      main: "#aaa",
      contrastText: "#fff",
    },

    primary: {
      main: "#507434",
    },
  },
});

function StagingInfo() {
  const idsOfItemsInStagingArea = useSelector(
    (state) => state.idsOfItemsInStagingArea
  );

  const numItemsInStagingArea = idsOfItemsInStagingArea.length;

  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch({
      type: "TRANSFER_STAGING_TO_CART",
    });
    dispatch({
      type: "CREATE_CART",
    });
  };

  if (numItemsInStagingArea === 0) {
    return (
      <Box>
        <Stack
          spacing={2}
          direction="row"
          sx={{
            display: {
              xs: "none",
              md: "flex",
              flexDirection: "row",
              alignItems: "center",
            },
          }}
        >
          <ThemeProvider theme={theme}>
            <IconButton
              color="neutral"
              aria-label="add to shopping cart"
              disabled
            >
              <AddShoppingCartIcon />
            </IconButton>
          </ThemeProvider>
        </Stack>
      </Box>
    );
  } else if (numItemsInStagingArea === 1) {
    return (
      <Box>
        <Stack
          spacing={2}
          direction="row"
          sx={{
            display: {
              xs: "none",
              md: "flex",
              flexDirection: "row",
              alignItems: "center",
            },
          }}
        >
          <Typography>{numItemsInStagingArea} item selected</Typography>

          <ThemeProvider theme={theme}>
            <Tooltip title="Transfer selected item from staging area to cart">
              <IconButton
                color="primary"
                aria-label="add to shopping cart"
                onClick={handleClick}
              >
                <AddShoppingCartIcon />
              </IconButton>
            </Tooltip>
          </ThemeProvider>
        </Stack>
      </Box>
    );
  } else {
    return (
      <Box>
        <Stack
          spacing={2}
          direction="row"
          sx={{
            display: {
              xs: "none",
              md: "flex",
              flexDirection: "row",
              alignItems: "center",
            },
          }}
        >
          <Typography>{numItemsInStagingArea} items selected</Typography>

          <ThemeProvider theme={theme}>
            <Tooltip title="Transfer selected items from staging area to cart">
              <IconButton
                color="primary"
                aria-label="add to shopping cart"
                onClick={handleClick}
              >
                <AddShoppingCartIcon />
              </IconButton>
            </Tooltip>
          </ThemeProvider>
        </Stack>
      </Box>
    );
  }
}

export default StagingInfo;
